import {
    FORMEDIT_CHOOSE_CURRENT_FORMSUBMIT,
} from './constants';
  
export function chooseCurrentFormSubmit(modal) {
    return {
      type: FORMEDIT_CHOOSE_CURRENT_FORMSUBMIT,
      data: modal,
    };
}
  
export function reducer(state, action) {
    switch (action.type) {
      case FORMEDIT_CHOOSE_CURRENT_FORMSUBMIT:
        return {
          ...state,
          currentFormSubmit:action.data,
        };
  
      default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/features/formedit/redux/chooseCurrentFormSubmit.js